<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Cashflow Dimension Transaction
        <span class="badge badge-info ml-2" v-if="model.sourceData">
          {{ model.sourceData === 'BUKU' ? 'Source: Journal GL (Buku)' : 'Source: Bank Trx (Tranbank)' }}
        </span>
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="process()">
            <i class="fa fa-play"></i> Process
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col xl="5">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-2 mr-2">Dimension</span></b-input-group-prepend
            >
            <b-form-select
              v-model="model.DimCol"
              :plain="true"
              :options="cfdimension"
              :state="!$v.model.DimCol.$error"
            ></b-form-select>
            <b-form-input
              readonly
              v-model="model.DimValInfo"
              placeholder="Dimension Value"
              :state="!$v.model.DimVal.$error"
              class="ml-1"
              style="width: 40% !important"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="showLkuDim">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col xl="7">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-2 mr-2"
                >Cashflow Account</span
              ></b-input-group-prepend
            >
            <b-form-input
              readonly
              v-model="model.kodeawinfo"
              :state="!$v.model.kodeaw.$error"
              style="width: 25% !important"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="showLkuCoa('kodeaw')">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-prepend
              ><span class="pt-2 mr-2">Trx. Date</span></b-input-group-prepend
            >
            <b-form-input
              v-model="model.tgl1"
              type="date"
              placeholder="from date"
              :state="!$v.model.tgl2.$error"
              class="mr-1"
            ></b-form-input>
            <b-form-input
              v-model="model.tgl2"
              type="date"
              placeholder="until date"
              :state="!$v.model.tgl2.$error"
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body>
        <b-table
          class="mb-0"
          ref="tableOri"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          style="font-size: smaller"
          :items="rptLines"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filterInput"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(tanggal)="data">{{
            data.item.tanggal | moment("D-MMM-YY")
          }}</template>
          <template v-slot:cell(nomor)="data">
            <b-link @click.stop="printJv(data.item)">{{
              data.item.nomor
            }}</b-link>
          </template>
          <template v-slot:cell(nilaibank)="data"
            >{{ data.item.matauang }}
            {{ data.item.nilaibank | numFormat("0,0.00") }}</template
          >
          <template v-slot:cell(umasuk)="data">{{
            data.item.umasuk | numFormat
          }}</template>
          <template v-slot:cell(ukeluar)="data">{{
            data.item.ukeluar | numFormat
          }}</template>
          <template v-slot:cell(namacash)="data">
            <span v-if="data.item.namacash" class="ml-2">
              {{ data.item.kodecash }} - {{ data.item.namacash }}</span
            >
            <div style="float: right">
              <a href="javascript:void(0)" @click.stop="edit(data.item)"
                ><i class="fa fa-pencil"></i></a
              >|
              <a
                href="javascript:void(0)"
                class="text-danger"
                @click.stop="clear(data.item)"
                ><i class="fa fa-trash"></i
              ></a>
            </div>
          </template>
        </b-table>

        <b-row class="m-1">
          <b-col lg="6">
            <b-row v-if="filterShow == 'Hide'">
              <b-input-group size="sm">
                <b-form-checkbox
                  v-model="filterShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                ></b-form-checkbox>
                <b-input-group-prepend>
                  <span class="pr-2">
                    <b> {{ filterShow }}</b> Filter
                  </span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
              <b-input-group size="sm" class="ml-4">
                <b-input-group-prepend class="ml-5">
                  <span class="pr-2">On</span>
                </b-input-group-prepend>
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox value="uraian">Description</b-form-checkbox>
                  <b-form-checkbox value="reff">Invoice/Reff</b-form-checkbox>
                  <b-form-checkbox value="nomor">Trx. Number</b-form-checkbox>
                  <b-form-checkbox value="nilai_lcy"
                    >Trx. Value (LCY)</b-form-checkbox
                  >
                  <b-form-checkbox value="nilaibank"
                    >Trx. Value (FCY)</b-form-checkbox
                  >
                </b-form-checkbox-group>
              </b-input-group>
              <label class="text-muted small" style="margin-left: 100px"
                >Leave all unchecked to filter on all data</label
              >
            </b-row>
            <b-row v-else>
              <b-form-checkbox
                v-model="filterShow"
                value="Hide"
                unchecked-value="Show"
                switch
              >
                <b> {{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-row>
          </b-col>
          <b-col lg="6">
            <div style="display: flex; margin: 0; padding: 0">
              <div
                style="margin: 0; padding: 5px; width: 500px; text-align: right"
              >
                Showing {{ (tblLcy.page - 1) * tblLcy.limit + 1 }} to
                <span v-if="tblLcy.page * tblLcy.limit > tblLcy.total">{{
                  tblLcy.total
                }}</span>
                <span v-else>{{ tblLcy.page * tblLcy.limit }}</span> of
                {{ tblLcy.total }} , <span class="mr-1">limit per page :</span>
                <select v-model="tblLcy.limit" style="width: 60px">
                  <option>10</option>
                  <option>15</option>
                  <option>20</option>
                  <option>25</option>
                  <option>30</option>
                  <option>40</option>
                  <option>50</option>
                  <option>60</option>
                  <option>70</option>
                  <option>80</option>
                  <option>90</option>
                </select>
              </div>
              <div>
                <b-pagination
                  class="ml-1"
                  align="left"
                  :total-rows="tblLcy.total"
                  :per-page="tblLcy.limit"
                  v-model="tblLcy.page"
                ></b-pagination>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showReport"
      size="xl"
      scrollable
      title="Preview as PDF"
      hide-footer
    >
      <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
      <b-row class="justify-content-center mt-1">
        <b-button variant="primary" @click.stop="editJurnal"
          >Edit Journal</b-button
        >
        <b-button variant="secondary" class="ml-2" @click="showReport = false">
          Close</b-button
        >
      </b-row>
    </b-modal>

    <b-modal
      v-model="lkuCashflowShow"
      size="lg"
      :hide-footer="true"
      title="List of Cashflow Account"
      :centered="true"
    >
      <lku-cashflow
        @click="onSelectLkuCashflow"
        :formdata="lkuCashflowData"
      ></lku-cashflow>
    </b-modal>
    <b-modal
      v-model="lkuDimShow"
      size="lg"
      :hide-footer="true"
      title="List of Dimension Value"
      :centered="true"
    >
      <lku-dim
        @click="onSelectedDim"
        :DimColName="model.DimCol"
        :key="model.DimCol"
      ></lku-dim>
    </b-modal>
    <b-modal
      v-model="lkuBankaccountShow"
      size="lg"
      :hide-footer="true"
      title="List of Bank/Cash Account"
      :centered="true"
    >
      <lku-bankaccount
        @click="onSelectLkuBankaccount"
        :formdata="lkuBankaccountData"
        aktif="1"
      ></lku-bankaccount>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped></style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import lkuDim from "../lookup/lkuDim";
import lkuCashflowShow from "../lookup/lkuCashflowLazzy";
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import cashflow from "../../apis/cashflow";
import myNumber from "../../components/my-number";
import toastr from "mini-toastr";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, lkuCashflowShow, lkuBankaccount, lkuDim, myNumber },
  mixins: [validationMixin],
  validations: {
    model: {
      kodeaw: { required },
      tgl1: { required },
      tgl2: { required },
      DimCol: { required },
      DimVal: { required },
    },
  },
  data() {
    return {
      cfdimension: [{ value: "bank", text: "Bank/Cash Account" }],
      model: {
        kodeaw: "",
        tgl1: "",
        tgl2: "",
        DimCol: "",
        DimVal: "",
        sourceData: "TRANBANK",
        tabIndex: 1,
      },
      rowModel: {},
      isLoading: false,
      reportUrl: null,
      showReport: false,
      tahun: moment(this.$store.state.user.tglaktif).format("YYYY"),
      lkuCashflowData: {},
      lkuCashflowShow: false,
      lkuCashflowCaller: "kodeaw",
      lkuBankaccountData: {},
      lkuBankaccountShow: false,
      lkuDimShow: false,
      rptLines: [],
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "tanggal",
            label: "Trx. Date",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "nomor",
            label: "Trx. Number",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true,
          },
          {
            key: "reff",
            label: "Invoice/Reff",
            thStyle: "width:100px",
            sortable: true,
          },
          {
            key: "namatable",
            label: "Trx.Source",
            thStyle: "width:80px",
            sortable: true,
          },
          {
            key: "createby",
            label: "Input By",
            thStyle: "width:80px",
            sortable: true,
          },
          {
            key: "nilaibank",
            label: "Value Original",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "umasuk",
            label: "Debit",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "ukeluar",
            label: "Credit",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "namacash",
            label: "CashFlow Account",
            thStyle: "width:330px",
            sortable: true,
          },
        ],
      },
      filterShow: "Show",
      filter: null,
      filterInput: null,
      filterOn: [],
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch: {
    filterShow: function (newval) {
      setTimeout(() => {
        if (this.filterShow == "Show") {
          this.filterInput = "";
          this.filter = "";
        }
      }, 200);
    },
    filter: function (newval) {
      setTimeout(() => {
        if (this.filterInput != newval) this.filterInput = newval;
      }, 800);
    },
  },

  created: async function () {
    // console.log("this.cfdimension : ", this.$store.state.dimension);
    // this.cfdimension = this.cfdimension.concat(this.$store.state.dimension);
    // console.log("this.cfdimension : ", this.cfdimension);
    setTimeout(() => {
      this.cfdimension = this.cfdimension.concat(this.dimension);
      console.log("this.cfdimension : ", this.cfdimension);
    }, 500);
    if (
      this.$route.params.tgl1 &&
      this.$route.params.tgl2 &&
      this.$route.params.kodeaw &&
      this.$route.params.DimCol &&
      this.$route.params.DimVal
    ) {
      this.model.kodeaw = this.$route.params.kodeaw;
      this.model.kodeawinfo = this.$route.params.kodeaw;
      this.model.tgl1 = this.$route.params.tgl1;
      this.model.tgl2 = this.$route.params.tgl2;
      this.model.DimValInfo =
        this.$route.params.DimValInfo || this.$route.params.DimVal;
      this.model.DimCol = this.$route.params.DimCol;
      this.model.DimVal = this.$route.params.DimVal;
      this.model.sourceData = this.$route.query.sourceData || "TRANBANK";

      this.process();
    } else {
      var tgl2 = moment(this.$store.state.user.tglaktif, "YYYY-MM-DD")
        .add(1, "M")
        .subtract(1, "day");
      this.model.tgl1 = `${tgl2.format("YYYY-MM")}-01`;
      this.model.tgl2 = tgl2.format("YYYY-MM-DD");
      this.tahun = tgl2.format("YYYY");
    }

    this.$watch("model.DimCol", function (newval) {
      this.model.DimVal = "";
      this.model.DimValInfo = "";
      const pilihan = this.cfdimension.find((d) => d.value === newval);
      if (pilihan) {
        this.model.DimVal = pilihan.text;
        this.model.DimColInfo = pilihan.text;
      }
    });
  },
  methods: {
    updateTgl1: function () {
      setTimeout(() => {
        var tgl2 = moment(this.model.tgl2, "YYYY-MM-DD");
        if (!this.model.tgl1) {
          this.model.tgl1 = `${tgl2.format("YYYY-MM")}-01`;
          this.tahun = tgl2.format("YYYY");
          this.$forceUpdate();
        } else {
          var tgl1 = moment(this.model.tgl1, "YYYY-MM-DD");
          if (tgl1.format("YYYY") !== tgl2.format("YYYY")) {
            this.model.tgl1 = `${tgl2.format("YYYY")}-01-01`;
            this.tahun = tgl2.format("YYYY");
            this.$forceUpdate();
          }
        }
      }, 1000);
    },
    updateTgl2: function () {
      setTimeout(() => {
        var tgl1 = moment(this.model.tgl1, "YYYY-MM-DD");
        if (!this.model.tgl2) {
          this.model.tgl2 = `${tgl1.format("YYYY")}-12-31`;
          this.tahun = tgl1.format("YYYY");
          this.$forceUpdate();
        } else {
          var tgl2 = moment(this.model.tgl2, "YYYY-MM-DD");
          if (tgl1.format("YYYY") !== tgl2.format("YYYY")) {
            this.model.tgl2 = `${tgl1.format("YYYY")}-12-31`;
            this.tahun = tgl1.format("YYYY");
            this.$forceUpdate();
          }
        }
      }, 1000);
    },
    onFiltered(filteredItems) {
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    process: async function (ctx) {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        const model = {};
        for (var key in this.model) {
          model[key] = this.model[key];
        }
        model.tgl1 = moment(this.model.tgl1).format("YYYY-MM-DD");
        model.tgl2 = moment(this.model.tgl2).format("YYYY-MM-DD");
        this.rptLines = await cashflow.cashflowtrx(model);
        this.tblLcy.total = this.rptLines.length;
        this.isLoading = false;
      }
    },
    print: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        try {
          const model = {};
          for (var key in this.model) {
            model[key] = this.model[key];
          }
          model.tgl1 = moment(this.model.tgl1).format("YYYY-MM-DD");
          model.tgl2 = moment(this.model.tgl2).format("YYYY-MM-DD");
          this.reportUrl = null; this.showReport = true;
          this.reportUrl = await cashflow.cashflowtrxprint(model);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    exportxls: async function () {
      if (this.invalidFilter) {
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const model = {};
          for (var key in this.model) {
            model[key] = this.model[key];
          }
          model.tgl1 = moment(this.model.tgl1).format("YYYY-MM-DD");
          model.tgl2 = moment(this.model.tgl2).format("YYYY-MM-DD");
          const response = await cashflow.cashflowtrxexport(model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    confirmAction: function (data) {
      if (this.model.tablekey === data.tablekey) {
        this.model.selected = 1;
        this.editAccCf();
      } else {
        if (this.model) this.model.selected = 0;
        this.model = data;
        this.model.selected = 1;
        this.$forceUpdate();
      }
    },
    editAccCf: async function () {
      if (this.model.selected) {
        this.showLkuCoa("model");
      } else {
        toastr.warn("Please select a row that want to be Edit CF Acc.!");
      }
    },
    async clearkodecash() {
      if (this.model.selected) {
        try {
          this.model.kodecash = "";
          this.model.namacash = "";
          // this.model.uraian= this.model.uraian.split(' <> ')[0]+' <> CF Account Cleared';
          this.model.edited = 1;
          this.model.selected = 0;
          await cashflow.clearkodecash(this.model);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be cleared!");
      }
    },
    edit: function (data) {
      if (this.model) this.model.selected = 0;
      this.model = data;
      this.model.selected = 1;
      // this.$forceUpdate();
      this.showLkuCoa("model");
    },
    clear: function (data) {
      if (this.model) this.model.selected = 0;
      this.model = data;
      this.model.selected = 1;
      // this.$forceUpdate();
      this.clearkodecash();
    },
    printJv: async function (data) {
      // this.showConfirmAction=false;
      // this.showList=true;
      if (data.nomor !== "") {
        try {
          toastr.info("PRINT VOUCHER in progress...");
          this.reportUrl = null; this.showReport = true;
          this.reportUrl = await cashflow.printjv(data);
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    async onSelectLkuCashflow(lkuData) {
      this.lkuCashflowData = lkuData;
      this.lkuCashflowShow = false;
      switch (this.lkuCashflowCaller) {
        case "kodeaw":
          this.model.kodeawinfo =
            lkuData.selected.kodecash.trim() +
            " | " +
            lkuData.selected.namacash.trim();
          this.model.kodeaw = lkuData.selected.kodecash;
          break;
        //     case 'kodeak':
        //         this.model.kodeakinfo = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
        //         this.model.kodeak = lkuData.selected.kodecash;
        //         break;
        default:
          if (this.model.kodecash !== lkuData.selected.kodecash) {
            // this.model.cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
            this.model.namacash = lkuData.selected.namacash;
            this.model.kodecash = lkuData.selected.kodecash;
            // this.model.uraian= this.model.uraian.split(' <> ')[0]+' <> CF Account edited to : '+ lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
            this.model.edited = 1;
            this.model.selected = 0;
            try {
              await cashflow.changekodecash(this.model);
            } catch (error) {
              if (error.message) {
                toastr.error(error.message);
              } else {
                toastr.error(JSON.stringify(error));
              }
            }
          }
          break;
      }
      this.lkuCashflowShow = false;
    },
    showLkuDim() {
      if (this.model.DimCol == "bank") {
        this.lkuBankaccountShow = true;
      } else {
        this.lkuDimShow = true;
      }
    },
    onSelectLkuBankaccount(lkuData) {
      this.lkuBankaccountData = lkuData;
      this.lkuBankaccountShow = false;
      this.model.DimVal = lkuData.selected.kodeacc;
      this.model.DimValInfo = `${lkuData.selected.kodeacc.trim()} | ${
        lkuData.selected.namabank
      } ${lkuData.selected.matauang}`;
      this.$forceUpdate();

      this.lkuBankaccountShow = false;
    },
    onSelectedDim: function (_selected) {
      this.model.DimVal = _selected.kode;
      this.model.DimValInfo = `${_selected.kode.trim()} | ${_selected.nama}`;
      this.$forceUpdate();
      this.lkuDimShow = false;
    },

    close() {
      router.push({ name: "treasury.home" });
    },
  },
};
</script>
